import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from 'react-i18next';
import { selectCurrentLanguage } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";

const DAY_MS = 24 * 60 * 60 * 1000;

const calendarDayNumber = date => Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
) / DAY_MS;

const DisplayTime = ({ createTime }) => {
    const { t } = useTranslation();
    const lang = useSelector(selectCurrentLanguage);
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), 60000);
        return () => clearInterval(interval);
    }, []);

    const relativeTime = useMemo(() => {
        const publishedAt = new Date(createTime);
        if (Number.isNaN(publishedAt.getTime())) return '';

        const currentDate = new Date(now);
        const calendarDays = Math.max(0, calendarDayNumber(currentDate) - calendarDayNumber(publishedAt));
        const elapsedMs = Math.max(0, now - publishedAt.getTime());
        const formatter = new Intl.RelativeTimeFormat(lang || 'en', { numeric: 'always' });

        if (calendarDays >= 1) return formatter.format(-calendarDays, 'day');

        const hours = Math.floor(elapsedMs / (60 * 60 * 1000));
        if (hours >= 1) return formatter.format(-hours, 'hour');

        const minutes = Math.floor(elapsedMs / (60 * 1000));
        if (minutes >= 1) return formatter.format(-minutes, 'minute');

        return t('now');
    }, [createTime, lang, now, t]);

    return <>{relativeTime}</>;
}

export default DisplayTime;
